export const FETCH_DESVIO_PADRAO = "desvio.fetch_desvio_passos";
export const FETCH_DESVIO_PADRAO_INIT = "desvio.fetch_desvio_passos_init";
export const FETCH_DESVIO_PADRAO_COMPLETE = "desvio.fetch_desvio_passos_complete";
export const FETCH_DESVIO_PADRAO_ERROR = "desvio.fetch_desvio_passos_error";
